import React from 'react';
import './Loader.css'
import classNames from "classnames";

const Loader = ({loadingType, className, childStyle, message, title}) => {
    const classes = classNames("loader", className)
    const spinner = (
        <div className={classes}>
            <div className="loader__item" style={childStyle}></div>
            <div className="loader__item" style={childStyle}></div>
            <div className="loader__item" style={childStyle}></div>
            <div className="loader__item" style={childStyle}></div>
        </div>
    );

    if (loadingType === 'dataType') {
        return spinner;
    }

    return (
        <div className="page-loader" role="status" aria-live="polite" aria-busy="true">
            {spinner}
            {(title || message) ? (
                <div className="page-loader__text">
                    {title ? <p className="page-loader__title">{title}</p> : null}
                    {message ? <p className="page-loader__message">{message}</p> : null}
                </div>
            ) : null}
        </div>
    );
};

export default Loader;
